import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

const getFundUrl = (id: string) => buildEndpoint(['fund', id, 'factsheetdata']);

export interface DividendPayment {
    paymentDate: string;
    amountPerParticipation: number;
}

export interface BasicCharacteristics {
    category: string;
    isin?: any;
    startDate: string;
    managementFee: number;
    totalAssets: number;
    numberOfParticipations: number;
    notInvestedAssets: number;
    fundManager: string;
    benchmark: string;
}

export interface DocumentUrls {
    essentialInvestmentInformation?: string;
    factsheetInformation?: string;
    umbrellaFundInformation?: string;
}

export interface RiskCharacteristics {
    riskClassification: number;
    standarddeviation36M: number;
    sharpeRatio36M: number;
    beta36M: number;
    rSquared36M: number;
    trackingError12M: number;
    grossTrackingDifference12M: number;
    netTrackingDifference12M: number;
}

export interface CharacteristicsUnderlyingStocks {
    numberOfStocks: number;
    averageMarketCapitalization: number;
    dividend: number;
    rentabilityOwnAssets: number;
    rateBookValueRatio: number;
    rateProfitRatio: number;
}

export interface CharacteristicsUnderlyingBonds {
    numberOfBonds: number;
    yieldToMaturity: number;
    averageCouponRate: number;
    averageDuration: number;
    averageCreditQuality: string;
    averageWeightedDuration: number;
}

export interface HistoricalReturn {
    historicalReturnTypeId: number;
    description: string;
    year: number;
    returnAfterCosts: number;
    returnBeforeCosts: number;
    returnBenchmark: number;
}

export interface Sector {
    sectorId: number;
    sectorName: string;
    sectorWeight: number;
}

export interface Region {
    regionId: number;
    regionName: string;
    regionWeight: number;
}

export interface Holding {
    holdingsName: string;
    holdingsWeight: number;
}

export interface Maturity {
    maturityId: number;
    maturityName: string;
    maturityWeight: number;
}

export interface CreditQuality {
    creditQualityId: number;
    creditQualityName: string;
    creditQualityWeight: number;
}

export interface GetFundResponse {
    fundId: string;
    dividendPayments: DividendPayment[];
    investmentStrategyText: string;
    referenceDateCharacteristics: string;
    basicCharacteristics: BasicCharacteristics;
    riskCharacteristics: RiskCharacteristics;
    documentUrls?: DocumentUrls;
    characteristicsUnderlyingStocks: CharacteristicsUnderlyingStocks;
    characteristicsUnderlyingBonds: CharacteristicsUnderlyingBonds;
    referenceDateHistoricalReturn: string;
    historicalReturns: HistoricalReturn[];
    referenceDateSectors: string;
    sectors: Sector[];
    referenceDateRegions: string;
    regions: Region[];
    referenceDateHoldings: string;
    holdings: Holding[];
    referenceDateMaturity: string;
    maturities: Maturity[];
    referenceDateCreditQuality: string;
    creditQualities: CreditQuality[];
}

export const getFundApiCall = (id: string) => apifetch<GetFundResponse>(getFundUrl(id), 'GET');

export const useGetFund = {};
